import { render, staticRenderFns } from "./notReturndetail.vue?vue&type=template&id=53de3ae4&scoped=true&"
import script from "./notReturndetail.vue?vue&type=script&lang=js&"
export * from "./notReturndetail.vue?vue&type=script&lang=js&"
import style0 from "./notReturndetail.vue?vue&type=style&index=0&id=53de3ae4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53de3ae4",
  null
  
)

export default component.exports